import React, { useEffect } from "react";
import { Popup } from "devextreme-react/popup";
import { Envase } from "../../dtos/Envase";
import "./DetallePopup.css";

interface DetallePopupProps {
  visible: boolean;
  onClose: () => void;
  activo: Envase | null;
}

type InfoFieldProps = {
  label: string;
  value?: React.ReactNode;
  span?: 1 | 2 | 3;
};

const InfoField: React.FC<InfoFieldProps> = ({ label, value, span = 1 }) => (
  <div className={`field span-${span}`}>
    <div className="field-label">{label}</div>
    <div className="field-value">
      {value !== null && value !== undefined && value !== "" ? value : "N/A"}
    </div>
  </div>
);

const StatusPill: React.FC<{ text?: string | null }> = ({ text }) => {
  const t = (text ?? "").toLowerCase();
  const tone = t.includes("activo") || t.includes("ok")
    ? "pill--success"
    : t.includes("baja") || t.includes("inactivo")
      ? "pill--danger"
      : "pill--neutral";
  return <span className={`pill ${tone}`}>{text ?? "N/A"}</span>;
};

const DetallePopup: React.FC<DetallePopupProps> = ({
  visible,
  onClose,
  activo,
}) => {
  useEffect(() => {
    if (visible) document.body.classList.add("no-scroll");
    else document.body.classList.remove("no-scroll");
    return () => document.body.classList.remove("no-scroll");
  }, [visible]);

  if (!visible || !activo) return null;

  const fechaRegistro = (() => {
    try {
      return activo.fechaRegistro
        ? new Date(activo.fechaRegistro).toLocaleDateString("es-MX")
        : "N/A";
    } catch {
      return "N/A";
    }
  })();

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      dragEnabled={false}
      position="center"
      shading
      closeOnOutsideClick
      showCloseButton
      showTitle
      titleRender={() => (
        <div className="custom-popup-title">
          <span className="title-dot" /> Detalles del Envase
        </div>
      )}
      width="92vw"
      maxWidth={980}
      height="auto"
      maxHeight="85vh"
      resizeEnabled
    >
      <div className="popup-scroll">
        <section className="card">
          <div className="info-grid">
            <InfoField label="Número de Serie" value={activo.numeroSerie} />
            <InfoField label="Código producto" value={activo.codigoProducto} />
            <InfoField
              label="Descripción producto"
              value={activo.descripcionProducto}
              span={3}
            />
            <InfoField label="Fabricante" value={activo.fabricante} />
            <InfoField label="Modelo" value={activo.modelo} />
            <InfoField label="Tipo envase" value={activo.tipoDeEnvase ?? activo.idTipoEnvase} />
            <InfoField
              label="Peso Tara"
              value={activo.pesoTara != null ? `${activo.pesoTara} kg` : undefined}
            />
            <InfoField label="Fecha de Registro" value={fechaRegistro} />
            <InfoField label="Cuerpo" value={activo.codigoCuerpo} />
            <InfoField label="Capuchón" value={activo.codigoCapuchon} />
            <InfoField label="Cuello" value={activo.codigoCuello} />
            <InfoField label="Estarcido" value={activo.codigoEstarcido} />
            <InfoField label="Ojiva" value={activo.codigoOjiva} />
            <InfoField label="Válvula" value={activo.valvula ?? activo.idValvula} />
            <InfoField label="Etiquetas impresas" value={activo.numeroEtiquetas} />
            <div className="field span-3">
              <div className="field-label">Estatus</div>
              <div className="field-value">
                <StatusPill text={activo.statusActivo} />
              </div>
            </div>
          </div>
        </section>

        <section className="card">
          <div className="section-title">Evidencia</div>
          {activo.evidencia ? (
            <a
              href={activo.evidencia}
              target="_blank"
              rel="noreferrer"
              className="evidencia-link"
            >
              <img
                src={activo.evidencia}
                alt="Evidencia del envase"
                className="evidencia-img"
                width={150}
                height={150}
              />
            </a>
          ) : (
            <div className="empty-evidence">Sin evidencia</div>
          )}
        </section>

        <div className="popup-footer">
          <button className="btn-cerrar" type="button" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default DetallePopup;
